/**
 * KraftStories – Search / Sort Modal (step-by-step wizard)
 *
 * Step 1 → Purpose  (auto-advance on selection)
 * Step 2 → Location (auto-advance; "Other City" reveals email capture instead of advancing)
 * Step 3 → Vibe     (manual submit via "Show me experiences")
 */
(function () {
    'use strict';

    var MODAL_ID    = 'kraft-search-sort-modal';
    var TOTAL_STEPS = 3;

    var PURPOSE_TO_PAGE = {
        'workshop':      '/pages/experiences',
        'team-building': '/pages/team-experiences',
        'private-event': '/pages/private-events',
        'date-night':    '/pages/experiences',
        'birthday':      '/pages/experiences'
    };

    var LOCATION_NORMALISE = {
        'Hawaii':        'hawaii',
        'Virtual':       'virtual',
        'San Francisco': 'san-francisco',
        'Los Angeles':   'los-angeles',
        'New York':      'new-york',
        'Irvine':        'irvine'
    };

    var STEP_CONTENT = [
        {
            title:    "What's the occasion?",
            subtitle: "Choose what brings your group together."
        },
        {
            title:    "Where are you based?",
            subtitle: "Pick your city and we'll show you what's available."
        },
        {
            title:    "What's the vibe?",
            subtitle: "Tell us the energy you're looking for."
        }
    ];

    var state = {
        currentStep: 1,
        selections: { purpose: null, location: null, vibe: null },
        otherEmail: ''
    };

    /* ---- DOM helpers ---- */

    function getModal() { return document.getElementById(MODAL_ID); }

    function goToStep(step) {
        var modal = getModal();
        if (!modal) return;

        state.currentStep = step;

        // Show / hide step panels
        modal.querySelectorAll('.kraft-search-sort-step').forEach(function (el) {
            el.classList.toggle('active', parseInt(el.getAttribute('data-step')) === step);
        });

        // Title + subtitle
        var titleEl    = modal.querySelector('[data-step-title]');
        var subtitleEl = modal.querySelector('[data-step-subtitle]');
        if (titleEl)    titleEl.textContent    = STEP_CONTENT[step - 1].title;
        if (subtitleEl) subtitleEl.textContent = STEP_CONTENT[step - 1].subtitle;

        // Back button visibility
        var backBtn = modal.querySelector('[data-step-back]');
        if (backBtn) backBtn.classList.toggle('visible', step > 1);

        // "Show me experiences" button: only on last step
        var btnWrap = modal.querySelector('.kraft-search-sort-btn-wrap');
        if (btnWrap) {
            btnWrap.classList.toggle('is-hidden', step !== TOTAL_STEPS);
            // Reset to disabled whenever we arrive at step 3 (re-entering counts too)
            if (step === TOTAL_STEPS) {
                var alreadySelected = state.selections.vibe !== null;
                btnWrap.classList.toggle('is-disabled', !alreadySelected);
            }
        }

        // Hide the "Other City" email panel when navigating away from step 2
        if (step !== 2) toggleOtherEmail(false);
    }

    function toggleOtherEmail(show) {
        var panel = document.getElementById('kraftLocationOther');
        if (panel) panel.classList.toggle('visible', show);
    }

    function buildURL() {
        var purpose  = state.selections.purpose  || '';
        var location = state.selections.location || '';
        var vibe     = state.selections.vibe     || '';
        var base     = PURPOSE_TO_PAGE[purpose]  || '/pages/experiences';
        var params   = [];
        if (purpose)  params.push('purpose='  + encodeURIComponent(purpose));
        if (location && location !== 'other') params.push('location=' + encodeURIComponent(location));
        if (vibe)     params.push('vibe='     + encodeURIComponent(vibe));
        return base + (params.length ? '?' + params.join('&') : '');
    }

    function saveOtherEmailAndAdvance() {
        var emailInput = document.getElementById('kraftLocationEmail');
        var email = emailInput ? emailInput.value.trim() : '';
        if (email) {
            state.otherEmail = email;
            localStorage.setItem('kraftLocationNotifyEmail', email);
        }
        state.selections.location = null;
        goToStep(3);
    }

    function submit() {
        var url = buildURL();
        if (window.KraftModals) window.KraftModals.close(MODAL_ID);
        setTimeout(function () { window.location.href = url; }, 300);
    }

    /* ---- Reset on each open ---- */

    function resetModal() {
        var modal = getModal();
        if (!modal) return;

        state.selections = { purpose: null, location: null, vibe: null };
        state.otherEmail = '';

        modal.querySelectorAll('.kraft-search-sort-chip').forEach(function (c) {
            c.classList.remove('active');
        });

        var emailInput = document.getElementById('kraftLocationEmail');
        if (emailInput) emailInput.value = '';
        toggleOtherEmail(false);

        var btnWrap = modal.querySelector('.kraft-search-sort-btn-wrap');
        if (btnWrap) btnWrap.classList.add('is-disabled');

        // Pre-fill location from the header location-selector localStorage
        var saved = localStorage.getItem('kraftWorkshopLocation');
        if (saved) {
            var norm = LOCATION_NORMALISE[saved] || saved.toLowerCase().replace(/\s+/g, '-');
            var chip = modal.querySelector('[data-filter-group="location"] [data-value="' + norm + '"]');
            if (chip) {
                chip.classList.add('active');
                state.selections.location = norm;
            }
        }

        goToStep(1);
    }

    /* ---- Initialise event listeners ---- */

    function initModal() {
        var modal = getModal();
        if (!modal) return;

        // Chip selection — single-select per group; auto-advance on steps 1 & 2
        modal.querySelectorAll('.kraft-search-sort-chip').forEach(function (chip) {
            chip.addEventListener('click', function () {
                var group     = this.closest('[data-filter-group]');
                if (!group) return;
                var groupName = group.getAttribute('data-filter-group');

                group.querySelectorAll('.kraft-search-sort-chip').forEach(function (c) {
                    c.classList.remove('active');
                });
                this.classList.add('active');
                state.selections[groupName] = this.getAttribute('data-value');

                // "Other City" in location: show email capture, don't auto-advance
                if (groupName === 'location' && state.selections.location === 'other') {
                    toggleOtherEmail(true);
                    var emailInput = document.getElementById('kraftLocationEmail');
                    if (emailInput) setTimeout(function () { emailInput.focus(); }, 50);
                    return;
                }

                // Hide email panel if switching away from "Other"
                if (groupName === 'location') toggleOtherEmail(false);

                // Enable submit button when vibe is selected (last step)
                if (groupName === 'vibe') {
                    var btnWrap = modal.querySelector('.kraft-search-sort-btn-wrap');
                    if (btnWrap) btnWrap.classList.remove('is-disabled');
                }

                // Auto-advance on steps 1 and 2
                if (state.currentStep < TOTAL_STEPS) {
                    setTimeout(function () { goToStep(state.currentStep + 1); }, 180);
                }
            });
        });

        // "Other City" email field — pressing Enter advances
        var emailInput = document.getElementById('kraftLocationEmail');
        if (emailInput) {
            emailInput.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') { e.preventDefault(); saveOtherEmailAndAdvance(); }
            });
        }

        // "Show me experiences" button — only on last step
        var nextBtn = modal.querySelector('[data-step-next]');
        if (nextBtn) {
            nextBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (state.currentStep === 2 && state.selections.location === 'other') {
                    saveOtherEmailAndAdvance();
                    return;
                }
                submit();
            });
        }

        // Back button
        var backBtn = modal.querySelector('[data-step-back]');
        if (backBtn) {
            backBtn.addEventListener('click', function () {
                if (state.currentStep > 1) goToStep(state.currentStep - 1);
            });
        }
    }

    /* ---- Listen for modal open ---- */

    window.addEventListener('modal:opened', function (e) {
        if (e.detail && e.detail.modalId === MODAL_ID) resetModal();
    });

    /* ---- Boot ---- */

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initModal);
    } else {
        initModal();
    }

})();
